// removed by extract-text-webpack-plugin
module.exports = {"sizeLabel":"_2oAR0JGS9y4TdV27L_NrNa","illustrationMargin":"_3E5pwDhJ6tMHitooUu_Sim"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/foundations/Illustrations/IllustrationsUsage/IllustrationsUsage.css
// module id = 774
// module chunks = 0